import { ConsoleLogger } from '@proposify/frontend-observability';
import type { NotificationPreferencesResponse } from './schemas';
import { NotificationPreferencesResponseSchema } from './schemas';
import { DEFAULT_PREFERENCES } from './schema-generators';
import { trackValidationFailure } from './validationTracking';

export const validateNotificationPreferencesResponse = (response: unknown): NotificationPreferencesResponse => {
  const result = NotificationPreferencesResponseSchema.safeParse(response);

  if (!result.success) {
    ConsoleLogger.warn('Notification preferences validation encountered issues:', {
      errors: result.error.errors,
      receivedData: response,
    });

    const responseObj = (response as Record<string, unknown>) || {};

    trackValidationFailure({
      label: 'Notification preferences response',
      cause: 'notification preferences response schema validation failed',
      error: result.error,
      responseObj,
    });

    return {
      userId: String(responseObj.userId || ''),
      availableEvents: Array.isArray(responseObj.availableEvents) ? responseObj.availableEvents : [],
      ...DEFAULT_PREFERENCES,
      ...(typeof responseObj === 'object' ? responseObj : {}),
    } as NotificationPreferencesResponse;
  }

  return result.data;
};
